<template>
  <layout>
    <page-header :header="$t('airports.create_airport')" />
    <div class="content">
      <b-card>
        <resource-form @saved="returnBack" @cancelled="returnBack" />
      </b-card>
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'airports'

export default {
  name: 'AirportCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
